import _ from 'lodash';
import React from 'react';
import { MdSave } from 'react-icons/md';
import Crud from '~/components/crud';
import { formats } from '~/helper';
import { RoleForm, RoleSchema } from '~/views/roles/form';
import { Container } from '~/views/roles/styles';
import CellStatus from '~/components/datatable/cell-status';
import useRoles from '~/view-data/use-roles';

const columns = [
  {
    name: '# Nome',
    selector: 'name',
    cell: (row) => {
      return (
        <CellStatus title={row.name} color={row.active ? '#53d449' : '#e6467f'}>
          <strong>{row.name}</strong>
        </CellStatus>
      );
    },
  },
  {
    name: 'Valor',
    selector: 'value',
    width: '150px',
    format: (row) => formats.currency(_.get(row, 'value'))
  },
  {
    name: 'Cadastrado em',
    selector: 'createdAt',
    width: '140px',
    hide: 'md',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function Roles({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = useRoles();

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhuma função encontrada'
        data={state.data}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        formTitle={(data) => (_.get(data, 'id')) ? `Função #${data.id}` : `Nova função`}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: RoleSchema,
          initialValues: state.model,
          initialTouched: { identify: true },
        }}
        renderForm={(args) => <RoleForm {...args} previewMode={!canWrite} />}
        actions={[
          {
            label: 'Salvar',
            icon: MdSave,
            isSubmit: true,
            isDisabled: ({ isValid }) => !isValid || !canWrite,
            action: actions.createOrUpdate,
          },
        ]}
      />
    </Container>
  );
}

export default Roles;
